import { useCallback } from 'react';
import { useSetAtom } from 'jotai';

import isSearchOpenAtom from './isSearchOpenAtom';

const useOpenSearch = () => {
  const setIsSearchOpen = useSetAtom(isSearchOpenAtom);

  const openSearch = useCallback(() => {
    setIsSearchOpen(true);
  }, [setIsSearchOpen]);

  return openSearch;
};

export default useOpenSearch;
